/**
 * ScoreDisplay Component
 * Unified score display for all games
 */

import React from 'react';
import { GAME_CONFIG } from '../config/gameConfig';

const ScoreDisplay = ({ score, level, highScore, stats }) => {
  return (
    <div style={styles.container}>
      <div style={styles.scoreBox}>
        <div style={styles.label}>Score</div>
        <div style={styles.value}>{score || 0}</div>
      </div>

      {level !== undefined && (
        <div style={styles.scoreBox}>
          <div style={styles.label}>Level</div>
          <div style={styles.value}>{level || 1}</div>
        </div>
      )}

      {highScore !== undefined && (
        <div style={styles.scoreBox}>
          <div style={styles.label}>High Score</div>
          <div style={styles.value}>{highScore || 0}</div>
        </div>
      )}

      {stats && typeof stats === 'object' && (
        Object.entries(stats).map(([key, value]) => (
          <div key={key} style={styles.scoreBox}>
            <div style={styles.label}>{key}</div>
            <div style={styles.value}>{value}</div>
          </div>
        ))
      )}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    gap: '1rem',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  scoreBox: {
    backgroundColor: `rgba(0, 0, 0, 0.3)`,
    border: `2px solid ${GAME_CONFIG.colors.primary}`,
    borderRadius: GAME_CONFIG.radius.lg,
    padding: '0.75rem 1rem',
    minWidth: '100px',
    textAlign: 'center',
  },
  label: {
    color: GAME_CONFIG.colors.light,
    fontSize: '0.85rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '0.25rem',
  },
  value: {
    color: GAME_CONFIG.colors.accent,
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
};

export default ScoreDisplay;
